import { useMutation } from '@gogame/query';
import { useScreenMessage } from '@gogame/screens';

import { exportIntegrations } from 'scenes/Integrations/sources/integrations';

import { exportInt } from '../queryKeyFactory';

export const useExportIntegrations = () => {
  const { showMessage } = useScreenMessage();
  const exportIntegrationsMutation = useMutation(
    exportInt(),
    exportIntegrations,
    {
      refresh: false,
      successMessage: () => 'Download complete',
    }
  );

  const handleAction = async (params) => {
    showMessage('Download has started');

    await exportIntegrationsMutation.mutateAsync(params);
  };

  return [handleAction, exportIntegrationsMutation];
};
